module.exports = __webpack_public_path__ + "media/src/assets/images/about_solution-pic2-d8d10c7a402046dc1d96af3a236fa02e.png";